import useCurrentUserId from "./useCurrentUserId";
import { toast } from 'sonner';
import { router } from "@inertiajs/react";

export default function useSignOut() {
  const userId = useCurrentUserId();
  
  return {
    signOut: async (e?: React.MouseEvent) => {
      if (e) e.preventDefault();
      const csrfToken = document.querySelector('meta[name="csrf-token"]')?.getAttribute('content');

      try {
        const response = await fetch("/users/sign_out", {
          method: "DELETE",
          headers: {
            "Content-Type": "application/json",
            "Accept": "application/json",
            "X-CSRF-Token": csrfToken || '',
          },
          credentials: 'same-origin'
        });

        const data = await response.json();

        if (response.ok) {
          toast.success("Logged out successfully! Redirecting...");
          // Redirect to home page
          setTimeout(() => {
            router.visit("/");
          }, 2000);
        } else {
          toast.error(data.error || "Logout failed");
        }
      } catch {
        toast.error("An error occurred during logout");
      }
    },
    isSignedIn: userId !== null,
  };
}
